import api from './api-caller';
import utils from '../mixins/utils';
const { getOrganizationPublicId } = utils.methods;

const baseEndpoint = '/organizations';


export default {
    listLandscapes: () => {
        let endpoint = `${baseEndpoint}/${getOrganizationPublicId()}/landscapes`
        return api(endpoint, 'GET')
    }
}
